import { computed, ref } from 'vue';
import { SPORT_LIVE_TV_WATCH_VIEWS } from '@/sport-live-tv/constants';
import { isSportLiveTvEventLive, getSportLiveTvEventSubtitle, getSportLiveTvEventTitle, getSportLiveTvStreamPickerSubtitle } from '@/sport-live-tv/helpers';
import { useSportLiveTvEvent } from '@/sport-live-tv/composables/use-sport-live-tv-event';
import { useSportLiveTvStream } from '@/sport-live-tv/composables/use-sport-live-tv-stream';

export const useWatchSportLiveTv = (eventId) => {
  const { event, isLoading, isError, refetch } = useSportLiveTvEvent(eventId);
  const stream = useSportLiveTvStream(event);
  const hasPlaybackError = ref(false);

  const handleStreamError = () => {
    hasPlaybackError.value = true;
  };

  const retryStream = () => {
    hasPlaybackError.value = false;
    stream.refetch();
  };

  const view = computed(() => {
    if (isError.value) return SPORT_LIVE_TV_WATCH_VIEWS.error;
    if (isLoading.value || !event.value) return SPORT_LIVE_TV_WATCH_VIEWS.loading;
    if (stream.hasNoSources.value || stream.isError.value || hasPlaybackError.value) return SPORT_LIVE_TV_WATCH_VIEWS.streamError;
    if (stream.needsChoice.value) return SPORT_LIVE_TV_WATCH_VIEWS.streamPicker;
    if (stream.isLoading.value || !stream.streamUrl.value) return SPORT_LIVE_TV_WATCH_VIEWS.loading;

    return SPORT_LIVE_TV_WATCH_VIEWS.player;
  });

  const title = computed(() => (event.value ? getSportLiveTvEventTitle(event.value) : ''));
  const subtitle = computed(() => (event.value ? getSportLiveTvEventSubtitle(event.value) : ''));
  const pickerSubtitle = computed(() => (event.value ? getSportLiveTvStreamPickerSubtitle(event.value) : ''));
  const isLive = computed(() => Boolean(event.value) && isSportLiveTvEventLive(event.value));

  return {
    view,
    title,
    subtitle,
    pickerSubtitle,
    isLive,
    sources: stream.sources,
    streamUrl: stream.streamUrl,
    selectStream: stream.selectStream,
    handleStreamError,
    retryStream,
    refetch,
  };
};
